<template>
  <div class="profil-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="7">
        <v-card class="profil-card elevation-0">
          <div class="profil-toolbar">
            <div class="profil-toolbar__left">
              <div class="profil-toolbar__icon">
                <v-icon>mdi-account-circle-outline</v-icon>
              </div>
              <div>
                <div class="profil-toolbar__title">Profil Pengguna</div>
                <div class="profil-toolbar__sub">
                  Kelola identitas akun gateway Anda
                </div>
              </div>
            </div>
            <v-btn
              class="profil-btn-primary"
              :loading="saving"
              :disabled="saving"
              @click="fetchUpdate"
            >
              <v-icon left small>mdi-content-save-outline</v-icon>
              Simpan Perubahan
            </v-btn>
          </div>

          <div class="profil-body">
            <div class="profil-avatar-block">
              <div class="profil-avatar-wrap">
                <v-avatar size="120" class="profil-avatar">
                  <v-img v-if="foto" :src="foto" alt="Avatar"></v-img>
                  <span v-else class="profil-avatar__initial">{{ initial }}</span>
                </v-avatar>
                <button
                  type="button"
                  class="profil-avatar__cam"
                  title="Ubah foto"
                  @click="uploadFoto"
                >
                  <v-icon small color="#0b3d2e">mdi-camera</v-icon>
                </button>
              </div>
              <div class="profil-avatar-meta">
                <div class="profil-avatar-meta__name">
                  {{ record.name || "Pengguna" }}
                </div>
                <div class="profil-avatar-meta__role">
                  {{ record.authent || "customer" }}
                </div>
                <button type="button" class="profil-avatar-meta__link" @click="uploadFoto">
                  Ganti foto profil
                </button>
              </div>
            </div>

            <div class="profil-form">
              <div class="profil-field-label">Nama lengkap</div>
              <v-text-field
                v-model="record.name"
                outlined
                dense
                hide-details="auto"
                color="#1f7a57"
                placeholder="Nama lengkap Anda"
                prepend-inner-icon="mdi-account-outline"
                class="profil-field mb-4"
              ></v-text-field>

              <div class="profil-field-label">Email</div>
              <v-text-field
                v-model="record.email"
                outlined
                dense
                hide-details="auto"
                color="#1f7a57"
                disabled
                prepend-inner-icon="mdi-email-outline"
                class="profil-field mb-4"
              ></v-text-field>

              <div class="profil-field-label">Nomor WhatsApp</div>
              <v-text-field
                v-model="record.phone"
                outlined
                dense
                hide-details="auto"
                color="#1f7a57"
                placeholder="62812xxxxxxxx"
                prepend-inner-icon="mdi-whatsapp"
                class="profil-field mb-2"
              ></v-text-field>
              <div class="profil-hint">
                Email tidak dapat diubah. Nomor dipakai untuk notifikasi akun.
              </div>
            </div>
          </div>

          <div class="profil-actions">
            <v-btn text class="profil-btn-ghost" to="/backend/chngpwd">
              Ganti kata sandi
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="profil-btn-primary"
              :loading="saving"
              :disabled="saving"
              @click="fetchUpdate"
            >
              <v-icon left small>mdi-check</v-icon>
              Simpan
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ProfilPengguna",
  data: () => ({
    foto: "",
    saving: false,
  }),
  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "record",
      "snackbar",
    ]),
    initial() {
      return String((this.record && this.record.name) || "U")
        .charAt(0)
        .toUpperCase();
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/",
      title: "PROFIL PENGGUNA",
      subtitle: "Kelola identitas dan foto akun Anda",
      breadcrumbs: [
        { text: "Utility", disabled: true, href: "" },
        { text: "Profil Pengguna", disabled: false, href: "" },
      ],
      actions: {
        refresh: false,
        add: false,
        edit: false,
        delete: false,
      },
      showtable: false,
    });
    this.fetchRecord();
  },
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "setRecord",
    ]),
    fetchRecord: async function () {
      try {
        let { data } = await this.http.get("api/user-info");
        this.setRecord(data || {});
        this.foto = data?.avatar_path || "";
      } catch (e) {}
    },
    fetchUpdate: async function () {
      if (!(this.record.name || "").trim()) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Nama lengkap wajib diisi";
        this.snackbar.state = true;
        return;
      }
      try {
        this.saving = true;
        let {
          data: { status, success, message, data },
        } = await this.http.post("api/utility/update-profil", this.record);

        const ok = status === true || success === true;
        if (!ok) {
          this.snackbar.color = "red";
          this.snackbar.text = message || "Gagal menyimpan profil";
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color || "green";
        this.snackbar.text = message || "Profil berhasil diperbarui";
        this.snackbar.state = true;

        if (data) this.setRecord(data);
        await this.fetchRecord();
        this.getUserInfo();
      } catch (error) {
        this.snackbar.color = "red";
        this.snackbar.text =
          error?.response?.data?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          "Terjadi kesalahan";
        this.snackbar.state = true;
      } finally {
        this.saving = false;
      }
    },
    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: { doctype: "avatars" },
        callback: (response) => {
          if (!response) return;
          this.foto = response.path;
          this.$set(this.record, "avatar", response.name);
        },
      });
    },
  },
};
</script>

<style scoped>
.profil-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.profil-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.profil-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.profil-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.profil-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.profil-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.profil-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
}

.profil-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.profil-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.profil-btn-ghost {
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--gw-leaf) !important;
  font-weight: 700 !important;
}

.profil-body {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 1.75rem;
  padding: 1.5rem 1.25rem 0.5rem;
}

.profil-avatar-block {
  text-align: center;
}

.profil-avatar-wrap {
  position: relative;
  display: inline-block;
}

.profil-avatar {
  border: 3px solid var(--gw-mint);
  background: var(--gw-fog);
}

.profil-avatar__initial {
  font-family: "Outfit", sans-serif;
  font-size: 2.4rem;
  font-weight: 700;
  color: var(--gw-forest);
}

.profil-avatar__cam {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
  cursor: pointer;
  display: grid;
  place-items: center;
}

.profil-avatar-meta {
  margin-top: 0.85rem;
}

.profil-avatar-meta__name {
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--gw-ink);
}

.profil-avatar-meta__role {
  font-size: 0.8rem;
  color: var(--gw-muted);
  text-transform: capitalize;
  margin-top: 0.15rem;
}

.profil-avatar-meta__link {
  margin-top: 0.55rem;
  border: 0;
  background: transparent;
  color: var(--gw-leaf);
  font-weight: 700;
  font-size: 0.82rem;
  cursor: pointer;
}

.profil-field-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--gw-forest);
  margin-bottom: 0.35rem;
}

.profil-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.profil-hint {
  font-size: 0.78rem;
  color: var(--gw-muted);
  margin-bottom: 0.5rem;
}

.profil-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.25rem 1.25rem;
  border-top: 1px solid var(--gw-line);
  margin-top: 0.75rem;
}

@media (max-width: 800px) {
  .profil-body {
    grid-template-columns: 1fr;
  }

  .profil-toolbar .profil-btn-primary {
    display: none;
  }
}
</style>
